import React, { createContext } from "react";
import { useQuery } from "react-query";
import { getAllPluginLogo } from "../api/home";

type DDRContextType = {
  pluginLogos: any;
};

export const DDRContext = createContext<DDRContextType>({
  pluginLogos: {},
});

const useLogos = () => {
  const [pluginLogos, setPluginLogos] = React.useState<any>({});

  const { data: pluginAll } = useQuery(["getAllPluginLogo"], getAllPluginLogo);

  React.useEffect(() => {
    if (pluginAll) {
      setPluginLogos(pluginAll || {});
    }
  }, [pluginAll]);
  return { pluginLogos };
};

export const DDRProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { pluginLogos } = useLogos();

  return (
    <DDRContext.Provider
      value={{
        pluginLogos,
      }}
    >
      {children}
    </DDRContext.Provider>
  );
};
